module.exports = __webpack_public_path__ + "gb-wls.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gb-wls.svg
// module id = 1163
// module chunks = 0